import React from 'react';
import { Fade } from '@material-ui/core';
import { FadeProps } from '@material-ui/core/Fade';

export default React.forwardRef<unknown, FadeProps>(
  /* eslint-disable react/jsx-props-no-spreading */
  (props, ref) => <Fade ref={ref} {...props} />,
);
